import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Menu, X } from 'lucide-react'
import { useLocale } from '../contexts/LocaleContext'
import { PORTAL_URL } from '../config'
import BrandMark from './BrandMark'
import LanguageSwitcher from './LanguageSwitcher'

/**
 * Section links are anchors on the landing page, so from any other route they have to
 * carry the path with them or they would scroll the wrong document.
 */
const Header: React.FC = () => {
  const { t } = useLocale()
  const { pathname } = useLocation()
  const [open, setOpen] = useState(false)

  const onHome = pathname === '/'
  const section = (id: string) => (onHome ? `#${id}` : `/#${id}`)

  const links = (
    <>
      <a href={section('functies')} className="text-text-secondary hover:text-text-primary">
        {t('navigation.features')}
      </a>
      <a href={section('prijzen')} className="text-text-secondary hover:text-text-primary">
        {t('navigation.pricing')}
      </a>
      <Link to="/contact" className="text-text-secondary hover:text-text-primary">
        {t('navigation.contact')}
      </Link>
      <a href={PORTAL_URL} className="text-text-secondary hover:text-text-primary">
        {t('navigation.login')}
      </a>
    </>
  )

  return (
    <header className="border-b border-border bg-surface-page">
      <div className="mx-auto flex max-w-[1280px] items-center justify-between gap-6 px-5 py-4 sm:px-8 lg:px-14">
        <Link to="/" className="flex items-center gap-2.5">
          <BrandMark />
          <span className="font-display text-2xl font-bold tracking-display text-text-primary">
            RallyShift
          </span>
        </Link>

        <nav className="hidden items-center gap-7 text-[15px] font-semibold lg:flex">
          {links}
          <LanguageSwitcher />
          <Link
            to="/signup"
            className="inline-flex min-h-touch-min items-center rounded-md bg-action-primary px-[22px] font-semibold text-text-on-primary hover:bg-action-primary-hover"
          >
            {t('navigation.startFreeTrial')}
          </Link>
        </nav>

        <button
          type="button"
          aria-expanded={open}
          aria-label="Menu"
          onClick={() => setOpen((v) => !v)}
          className="inline-flex h-11 w-11 items-center justify-center rounded-md text-text-primary lg:hidden"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <nav className="flex flex-col gap-4 border-t border-border px-5 py-5 text-[15px] font-semibold lg:hidden">
          {links}
          <LanguageSwitcher />
          <Link
            to="/signup"
            className="inline-flex min-h-touch-comfort items-center justify-center rounded-md bg-action-primary px-6 font-semibold text-text-on-primary"
          >
            {t('navigation.startFreeTrial')}
          </Link>
        </nav>
      )}
    </header>
  )
}

export default Header
